/**
 * 产品信息类型（/api/product/info/:soft_id 返回）
 * @module types/product
 */

/** 产品信息 */
export interface ProductInfo {
  /** 兼容旧版：邀请赠送积分 */
  givePoint: number
  /** 每日分享最大奖励次数 */
  point_share_max_counts: number
  /** 每次分享赠送积分 */
  share_give_points: number
  /** 每日邀请最大奖励次数 */
  point_invite_max_count: number
  /** 每次邀请赠送积分 */
  invite_give_points: number
  /** 被邀请人赠送积分 */
  invitee_give_points: number
  /** 每日邀请最大奖励会员次数 */
  invite_give_vip_max_count: number
  /** 每次邀请赠送会员天数 */
  invite_give_vip_day: number
  /** 被邀请人赠送会员天数 */
  invitee_give_vip_day: number
  /** 每日最大签到次数 */
  point_signin_max_count: number
  /** 每次签到赠送积分 */
  signin_give_points: number
  /** 每次对话赠送积分 */
  daily_conversation_points: number
  /** 注册赠送积分 */
  register_give_points: number
  /** 会员每月赠送积分 */
  member_give_point: number
  /** 分佣比例(%) */
  commission_rate: number
  /** 分佣提现最小值(元) */
  commission_withdrawal_limit: number
  /** 产品扩展参数 */
  params?: ProductParams
}

/** 产品扩展参数 */
export interface ProductParams {
  /** 是否仅允许会员签到，只有显式 true 才限制 */
  is_vip_check_in?: boolean
  /** 是否开启直播浮块 */
  live_status?: boolean
  [key: string]: unknown
}

/** 默认产品信息 */
export const DEFAULT_PRODUCT_INFO: ProductInfo = {
  givePoint: 0,
  point_share_max_counts: 0,
  share_give_points: 0,
  point_invite_max_count: 0,
  invite_give_points: 0,
  invitee_give_points: 0,
  invite_give_vip_max_count: 0,
  invite_give_vip_day: 0,
  invitee_give_vip_day: 0,
  point_signin_max_count: 0,
  signin_give_points: 0,
  daily_conversation_points: 0,
  register_give_points: 0,
  member_give_point: 0,
  commission_rate: 0,
  commission_withdrawal_limit: 0,
  params: {}
}
